import { render, staticRenderFns } from "./BaseSplitSelect.vue?vue&type=template&id=9a8e1bb4&scoped=true"
import script from "./BaseSplitSelect.vue?vue&type=script&lang=js"
export * from "./BaseSplitSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSplitSelect.vue?vue&type=style&index=0&id=9a8e1bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e1bb4",
  null
  
)

export default component.exports